import React from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ExistingOrders } from "./ExistingOrders";
import {
	CUSTOMER_UNIT_QUOTE_LIST_REQUEST,
	SAVE_SELECTED_EXISTING_ORDER_REQUEST,
	PRINT_PDF_REQUEST,
} from "../../../_utils/constants/Customer";
import { STORE_INFO_REQUEST } from "../../../_utils/constants/admin/StoreInfo";
import { QUOTE_MODE_KEY } from "../../../_utils/quoteMode";

const UnitQuotes = (props) => {
	const navigate = useNavigate();
	const handleGenerateNewQuote = () => {
		localStorage.setItem(QUOTE_MODE_KEY, "true");
		navigate("/unit-quotes/new");
	};
	return (
		<ExistingOrders
			{...props}
			isQuoteView={true}
			jobNoLabel="Quote No."
			pageTitle="Unprocessed Quotes"
			onGenerateNewQuote={handleGenerateNewQuote}
		/>
	);
};

const mapStateToProps = ({ auth, customerInfo, StoreInfo }) => {
	return {
		auth,
		customerInfo: {
			...customerInfo,
			existingOrderList: customerInfo.unitQuoteList,
			totalCount: customerInfo.unitQuoteTotalCount,
			isLoading: customerInfo.isLoading,
			savedExistingOrder: customerInfo.savedExistingOrder,
			printingPdf: customerInfo.printingPdf,
			isPdfProcessing: customerInfo.isPdfProcessing,
		},
		StoreInfo,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		fetchExistingOrdersList: (token, sort, page, paginate, listParamState) =>
			dispatch({ type: CUSTOMER_UNIT_QUOTE_LIST_REQUEST, token, sort, page, paginate, listParamState }),
		fetchStoreInfo: (token) => dispatch({ type: STORE_INFO_REQUEST, token }),
		saveExistingOrdersList: (token, payload) => dispatch({ type: SAVE_SELECTED_EXISTING_ORDER_REQUEST, token, payload }),
		generatePdf: (token, payload) => dispatch({ type: PRINT_PDF_REQUEST, token, payload }),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(UnitQuotes);
